export default __webpack_public_path__ + "static/media/Polygon.18cfcd66.svg";